import { makeStyles } from '@mui/styles'

export default makeStyles((theme) => ({
    tableActions: {
        display: 'flex',
        justifyContent: 'start',
        alignItems: 'center',
        gap: '8px',
        flexWrap: 'wrap',
    },
    dialogForm: {
        display: 'grid',
        gap: '1.5rem',
    },
}))